app.service('questionService', [
  'portalHelper',
  function (portalHelper) {
    let questionService = this;
    const MIN_OPTIONS_LENGTH = 3;

    /**
     * get items pasted from word
     * @param {boolean} isPastingFromWord specifies if paste from word option is enabled
     * @param {event} pasteEvent
     * @returns {array} list of text items
     */
    questionService.get_options_pasted_from_word = function (isPastingFromWord, pasteEvent) {
      if (!isPastingFromWord) {
        return [];
      }

      let options = portalHelper.get_list_items_from_paste_event(pasteEvent);
      if (!options.length) {
        return [];
      }

      // prevent default browser paste action, (pasting raw text)
      pasteEvent.preventDefault();

      return options;
    };

    /**
     * updated curent options with optionsToAdd
     * @param {object} currOptions specifies current options for the question
     * @param {number} currIndex specifies index of current selected item
     * @param {array} optionsToAdd specifies new options to be added
     */
    questionService.get_updated_options = function (currOptions, currIndex, optionsToAdd) {
      let len = 0;
      let i = 0;
      let options = [];
      // get valid(non empty) options before currIndex
      for (i = 0; i < currIndex; ++i) {
        let option = currOptions[i];
        if (option.option_name) {
          options.push({
            option_name: option.option_name,
            option_value: ++len
          });
        }
      }

      // push pasted listItems
      for (i = 0; i < optionsToAdd.length; ++i) {
        options.push({
          option_name: optionsToAdd[i].text,
          option_value: ++len
        });
      }

      // push non empty options after the currIndex
      for (i = currIndex + 1; i < currOptions.length; ++i) {
        let option = currOptions[i];
        if (option.option_name) {
          options.push({
            option_name: option.option_name,
            option_value: ++len
          });
        }
      }

      // insert empty elements at the last to ensure we have minimum
      // 3 options
      if (len < MIN_OPTIONS_LENGTH) {
        options.push({
          option_name: '',
          option_value: ++len
        });
      }

      return options;
    };

    /**
     * updated curent options with optionsToAdd
     * @param {object} currOptions specifies current options for the question
     * @param {number} currIndex specifies index of current selected item
     * @param {array} optionsToAdd specifies new options to be added
     */
    questionService.get_updated_options_for_ranking_questions = function (currOptions, currIndex, optionsToAdd) {
      let len = 0;
      let i = 0;
      let options = [];
      // get non empty options before currIndex
      for (i = 0; i < currIndex; ++i) {
        let option = currOptions[i];
        if (option.option_name[0]) {
          options.push({
            option_name: option.option_name,
            sequence_number: ++len
          });
        }
      }

      // push pasted listItems
      for (i = 0; i < optionsToAdd.length; ++i) {
        options.push({
          option_name: [optionsToAdd[i].text],
          sequence_number: ++len
        });
      }

      // push non empty options after the currIndex
      for (i = currIndex + 1; i < currOptions.length; ++i) {
        let option = currOptions[i];
        if (option.option_name[0]) {
          options.push({
            option_name: option.option_name,
            sequence_number: ++len
          });
        }
      }

      // insert empty elements at the last to ensure we have minimum
      // 3 options
      if (len < MIN_OPTIONS_LENGTH) {
        options.push({
          option_name: [''],
          sequence_number: ++len
        });
      }

      return options;
    };
  }
]);